'use client';
import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { Avatar as d, AvatarFallback as m } from "@radix-ui/react-avatar";
import { Icon as a } from "@tameeni/icons";
import { useScreenSize as h } from "@tameeni/shared-logic";
import { DropdownMenu as o, DropdownMenuTrigger as x, Button as f, DropdownMenuContent as w } from "@tameeni/ui";
const y = ({
  user: l,
  profileMenuItems: r,
  onLogout: s,
  logoutLabel: i
}) => {
  const { isMobile: p } = h();
  return /* @__PURE__ */ t(o, { children: [
    /* @__PURE__ */ e(x, { asChild: !0, children: /* @__PURE__ */ t(
      f,
      {
        variant: "text",
        className: "relative flex min-h-fit h-fit px-1 min-w-fit w-fit md:justify-center items-center gap-2 text-slate-600 focus:outline-none focus-visible:ring-white",
        children: [
          /* @__PURE__ */ e(
            a,
            {
              width: "22",
              height: "22",
              name: "User",
              className: "md:hidden h-5 w-5 fill-slate-600"
            }
          ),
          /* @__PURE__ */ t("div", { className: "hidden md:flex gap-2 justify-center items-center", children: [
            /* @__PURE__ */ e(
              a,
              {
                width: "24",
                height: "24",
                name: "Login",
                className: "fill-blue-600 size-6"
              }
            ),
            /* @__PURE__ */ e("span", { className: "text-sm", children: l.name }),
            /* @__PURE__ */ e(
              a,
              {
                width: "12",
                height: "12",
                name: "ChevronDown",
                className: "w-3 h-3"
              }
            )
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ e(w, { className: "bg-white shadow-sm rounded-md ", children: /* @__PURE__ */ t("div", { className: "w-[300px] bg-white flex flex-col", children: [
      /* @__PURE__ */ t("div", { className: "flex items-start gap-3 p-4 border-b rtl:flex-row-reverse", children: [
        /* @__PURE__ */ e("div", { className: "relative", children: /* @__PURE__ */ e(d, { className: "h-14 w-14 rounded-full items-center justify-center flex bg-blue-200", children: /* @__PURE__ */ e(m, { children: /* @__PURE__ */ e(a, { name: "ProfileDropDown", className: "h-8 w-8" }) }) }) }),
        /* @__PURE__ */ t("div", { className: "flex flex-col p-1", children: [
          /* @__PURE__ */ e("div", { className: "flex items-center justify-between gap-3 rtl:flex-row-reverse", children: /* @__PURE__ */ e("span", { className: "text-s1 text-slate-900 truncate max-w-[200px]", children: l.name }) }),
          /* @__PURE__ */ e("span", { className: "text-b2 text-gray-500 rtl:text-end", children: l.id })
        ] })
      ] }),
      /* @__PURE__ */ e("nav", { className: "flex-1 border-b border-slate-200", children: /* @__PURE__ */ e("ul", { children: r == null ? void 0 : r.map((n, c) => /* @__PURE__ */ e(N, { ...n }, c)) }) }),
      /* @__PURE__ */ t(
        "div",
        {
          onClick: s,
          className: "flex gap-4 p-4 text-b2 text-slate-400 cursor-pointer rtl:flex-row-reverse",
          children: [
            /* @__PURE__ */ e(a, { name: "Logout", className: "h-6 w-6 rtl:rotate-180" }),
            /* @__PURE__ */ e("span", { children: i })
          ]
        }
      )
    ] }) })
  ] });
};
function N(l) {
  return /* @__PURE__ */ e("li", { className: "p-4", children: /* @__PURE__ */ t(
    "a",
    {
      href: l.link,
      className: "flex items-center justify-start gap-4 text-b2 text-slate-900 rtl:flex-row-reverse",
      children: [
        /* @__PURE__ */ e("span", { className: "flex-shrink-0", children: /* @__PURE__ */ e(
          a,
          {
            width: "24",
            height: "24",
            className: "w-4 h-4 md:w-6 md:h-6",
            name: l.icon
          }
        ) }),
        /* @__PURE__ */ e("span", { children: l.label })
      ]
    }
  ) });
}
export {
  y as UserNav
};
//# sourceMappingURL=user-dropdown.js.map
